/**
 * abilityVfxRuneCage — Ryze W Rune Prison arcane cage (SP-10).
 */
export function buildRuneCage(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.1);
  const ink = mat(THREE, spec.color || 0x818cf8, 0.9);
  const glow = mat(THREE, 0xc7d2fe, 0.85);
  const deep = mat(THREE, 0x6366f1, 0.88);
  addPillarsAndGlyphs(THREE, group, s, ink, glow, deep);
  addConnectingBeams(THREE, group, s, ink);
  addGroundRings(THREE, group, s, ink, glow);
  addCenterLock(THREE, group, s, glow);
  group.userData = { shape: 'rune_cage' };
  return group;
}

function addPillarsAndGlyphs(THREE, group, s, ink, glow, deep) {
  for (let i = 0; i < 4; i += 1) {
    const a = (Math.PI / 2) * i;
    const x = Math.cos(a) * s;
    const z = Math.sin(a) * s;
    const post = new THREE.Mesh(new THREE.BoxGeometry(0.1 * s, 1.2 * s, 0.1 * s), deep);
    post.position.set(x, 0.6 * s, z);
    group.add(post);
    const glyph = new THREE.Mesh(new THREE.BoxGeometry(0.14 * s, 0.22 * s, 0.05 * s), glow);
    glyph.position.set(x, 0.75 * s, z);
    group.add(glyph);
    const cap = new THREE.Mesh(new THREE.SphereGeometry(0.08 * s, 8, 8), ink);
    cap.position.set(x, 1.15 * s, z);
    group.add(cap);
  }
}

function addConnectingBeams(THREE, group, s, ink) {
  for (let i = 0; i < 4; i += 1) {
    const a0 = (Math.PI / 2) * i;
    const a1 = (Math.PI / 2) * ((i + 1) % 4);
    const x0 = Math.cos(a0) * s;
    const z0 = Math.sin(a0) * s;
    const x1 = Math.cos(a1) * s;
    const z1 = Math.sin(a1) * s;
    const beam = new THREE.Mesh(new THREE.BoxGeometry(0.06 * s, 0.06 * s, s * 1.05), ink);
    beam.position.set((x0 + x1) / 2, 1.0 * s, (z0 + z1) / 2);
    if (!beam.rotation) beam.rotation = { y: 0 };
    beam.rotation.y = a0 + Math.PI / 4;
    group.add(beam);
  }
}

function addGroundRings(THREE, group, s, ink, glow) {
  const outer = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.75, s * 1.05, 20).rotateX(-Math.PI / 2),
    ink
  );
  outer.position.y = 0.05;
  group.add(outer);
  const inner = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.35, s * 0.55, 16).rotateX(-Math.PI / 2),
    glow
  );
  inner.position.y = 0.06;
  group.add(inner);
}

function addCenterLock(THREE, group, s, glow) {
  const lock = new THREE.Mesh(new THREE.SphereGeometry(0.2 * s, 10, 10), glow);
  lock.position.y = 0.45 * s;
  group.add(lock);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
